import {
  AccountBox,
  RssFeed,
  Group, Home,
  Message,
  PieChart,
  PlaylistPlay,
  Settings,
  Sort,
  Dashboard,
  VideocamRounded as Videocam, ShowChart
} from "@material-ui/icons";

import Tags from "../views/Tags";
import TagGroups from "../views/TagGroups";
import Playlists from "../views/Lists";
import Users from "../views/Users";
import Sections from "../views/Sections";
import localization from "../config/localization";
import UserProfile from "../views/UserProfile";
import Search from "../views/Search";
import VideoConfig from "../views/VideoConfig";
import FeaturedImages from "../views/FeaturedImages";
import AuditLog from "../views/AuditLog";
import Pitches from "../views/Pitches";
import ContentCreators from "../views/ContentCreators";
import ContentCreations from "../views/ContentCreations";
import Links from "../views/Links";
import ContentCreatorTypes from "../views/ContentCreatorTypes"
import LiveStreams from "../views/LiveStreams";
import Reels from "../views/Reels"
import Metrics from "../views/Metrics"

import {
  ROLES,
  storeActiveHome, storeActiveSection,
  userIsAnyOf,
  userIsOrOutranksRole,
} from "../api-client/core/authentication/utils";

import {isNullOrUndefined} from "util";
import LoginAttempts from "../views/LoginAttempts";
import HomeEditor from "../views/HomeEditor";

const redirectToDashboardKey = "dashboard.redirect_to_dashboard";

export const getRedirectToDashboardStoredValue = () => {
  let val = localStorage.getItem(redirectToDashboardKey);

  if (isNullOrUndefined(val)) {
    setRedirectToDashboardStoredValue(true);

    return true;
  }

  return val === "true";
};

export const setRedirectToDashboardStoredValue = flag =>
  localStorage.setItem(redirectToDashboardKey, flag);

const makeRoutes = () => {
  const dashboardRoute = {
    icon: ShowChart,
    name: "Metricas",
    hidden: false,
    path: "/panel/dashboard",
    component: Metrics,
    forRoleIn: [ROLES.SUPERVISOR, ROLES.SYS_ADMIN]
  };

  const clientsRoute = {
    collapse: true,
    name: "Bloomclouds",
    state: "openClient",
    icon: Dashboard,
    forRoleIn: [ROLES.SUPERVISOR, ROLES.SYS_ADMIN, ROLES.MULTI_CLIENT],
    views: [
      {
        path: "/panel/users",
        name: localization.get("users"),
        icon: Group,
        component: Users,
        forRoleIn: [ROLES.SUPERVISOR, ROLES.SYS_ADMIN, ROLES.MULTI_CLIENT],
      },
      {
        path: "/panel/home",
        name: localization.get("home_editor"),
        icon: Home,
        component: HomeEditor,
        forRoleIn: [ROLES.SUPERVISOR, ROLES.SYS_ADMIN, ROLES.MULTI_CLIENT],
      },
      {
        path: "/panel/sections",
        name: localization.get("sections"),
        component: Sections,
        forRoleIn: [ROLES.SUPERVISOR, ROLES.SYS_ADMIN, ROLES.MULTI_CLIENT],
      },
      {
        path: "/panel/livestreams",
        name: localization.get("livestreams"),
        icon: Home,
        component: LiveStreams,
        forRoleIn: [ROLES.SUPERVISOR, ROLES.SYS_ADMIN, ROLES.MULTI_CLIENT],
      },
      {
        path: "/panel/pitches",
        name: localization.get("projects"),
        icon: Message,
        component: Pitches,
      },
      {
        path: "/panel/playlists",
        name: localization.get("playlists"),
        icon: PlaylistPlay,
        component: Playlists,
        forRoleEqualOrHigherThan: ROLES.SYS_ADMIN
      },
      {
        path: "/panel/links",
        name: localization.get("links"),
        icon: Message,
        component: Links,
      },
      {
        path: "/panel/reels",
        name: localization.get("reels"),
        component: Reels,
      }
    ]
  };

  const talentsRoute = {
    collapse: true,
    name: localization.get("talents"),
    icon: AccountBox,
    state: "openTalents",
    forRoleIn: [ROLES.SUPERVISOR, ROLES.SYS_ADMIN],
    views: [
      {
        path: "/panel/talents/content_creators",
        name: localization.get("content_creators"),
        component: ContentCreators
      },
      {
        path: "/panel/talents/content_creator_types",
        name: localization.get("content_creator_categories"),
        component: ContentCreatorTypes
      },
      {
        path: "/panel/talents/content_creations",
        name: localization.get("content_creations.materials"),
        component: ContentCreations,
        hidden: true,
      },
      {
        path: "/panel/talents/tag_groups",
        name: localization.get("tag_groups"),
        component: TagGroups
      },
      {
        path: "/panel/talents/tags",
        name: localization.get("tags"),
        component: Tags
      },
    ],
  };

  const audiovisualRoute = {
    collapse: true,
    name: localization.get("production"),
    icon: Videocam,
    state: "openAudiovisual",
    forRoleIn: [ROLES.SUPERVISOR, ROLES.SYS_ADMIN],
    views: [
      {
        path: "/panel/audiovisual/content_creators",
        name: localization.get("content_creators"),
        component: ContentCreators
      },
      {
        path: "/panel/audiovisual/content_creator_types",
        name: localization.get("content_creator_categories"),
        component: ContentCreatorTypes
      },
      {
        path: "/panel/audiovisual/content_creations",
        name: localization.get("content_creations.materials"),
        component: ContentCreations,
        hidden: true,
      },
      {
        path: "/panel/audiovisual/tag_groups",
        name: localization.get("tag_groups"),
        component: TagGroups
      },
      {
        path: "/panel/audiovisual/tags",
        name: localization.get("tags"),
        component: Tags
      },
    ],
  };

  const editorialRoute = {
    collapse: true,
    name: localization.get("editorial"),
    icon: RssFeed,
    state: "openEditorial",
    forRoleIn: [ROLES.SUPERVISOR, ROLES.SYS_ADMIN],
    views: [
      {
        path: "/panel/editorial/content_creators",
        name: localization.get("content_creators"),
        component: ContentCreators
      },
      {
        path: "/panel/editorial/content_creator_types",
        name: localization.get("content_creator_categories"),
        component: ContentCreatorTypes
      },
      {
        path: "/panel/editorial/content_creations",
        name: localization.get("content_creations.materials"),
        component: ContentCreations,
        hidden: true,
      },
      {
        path: "/panel/editorial/tag_groups",
        name: localization.get("tag_groups"),
        component: TagGroups
      },
      {
        path: "/panel/editorial/tags",
        name: localization.get("tags"),
        component: Tags
      },
    ],
  };

  const configurationRoute = {
    collapse: true,
    name: localization.get("settings"),
    state: "openConfiguration",
    icon: Settings,
    views: [
      {
        path: "/panel/videos",
        name: localization.get("banners"),
        component: VideoConfig
      },
      {
        path: "/panel/featured_images",
        name: localization.get("featured_images"),
        component: FeaturedImages
      },
    ],
    forRoleEqualOrHigherThan: ROLES.SYS_ADMIN
  };

  const reportsRoute = {
    collapse: true,
    name: localization.get("reports"),
    icon: PieChart,
    state: "openReports",
    forRoleIn: [ROLES.SUPERVISOR, ROLES.SYS_ADMIN],
    views: [
      {
        path: "/panel/auditLogs",
        name: localization.get("audit"),
        icon: Sort,
        component: AuditLog,
        forRoleEqualOrHigherThan: ROLES.SYS_ADMIN
      },
      {
        path: "/panel/loginAttempts",
        name: localization.get("login_attempts"),
        component: LoginAttempts,
        forRoleEqualOrHigherThan: ROLES.SYS_ADMIN
      },
    ]
  };

  const searchRoute = {
    hidden: true,
    path: "/panel/search",
    component: Search,
    forRoleEqualOrHigherThan: ROLES.SYS_ADMIN
  };

  const profileRoute = {
    hidden: true,
    path: "/panel/profile",
    component: UserProfile,
    forRoleIn: [ROLES.SUPERVISOR, ROLES.SYS_ADMIN, ROLES.MULTI_CLIENT],
  };

  const redirectRoute = () => {
    let pathTo;
    let name;

    pathTo = "/panel/dashboard";
    name = localization.get("dashboard");

    return {
      redirect: true,
      path: "/",
      pathTo: pathTo,
      name: name
    };
  };

  const routes = [];

  const userCanAccess = item => {
    if (
      !isNullOrUndefined(item.forRoleEqualOrHigherThan) &&
      !userIsOrOutranksRole(item.forRoleEqualOrHigherThan)
    ) {
      return false;
    }
    if (!isNullOrUndefined(item.forRoleIn) && !userIsAnyOf(item.forRoleIn)) {
      return false;
    }
    return true;
  };

  const addRoute = route => {
    if (!userCanAccess(route)) {
      return routes;
    }
    if (!isNullOrUndefined(route.views)) {
      const acceptedViews = [];
      route.views.forEach(view => {
        if (userCanAccess(view)) {
          acceptedViews.push(view);
        }
      });
      route.views = acceptedViews;
    }

    routes.push(route);
    return routes;
  };

  storeActiveHome(null);
  storeActiveSection(false);

  addRoute(dashboardRoute);
  addRoute(clientsRoute);
  addRoute(talentsRoute);
  addRoute(audiovisualRoute);
  addRoute(editorialRoute)
  addRoute(reportsRoute);
  //addRoute(configurationRoute);
  addRoute(searchRoute);
  addRoute(profileRoute);
  addRoute(redirectRoute());

  return routes;
};

export default makeRoutes;
